import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import Button from '../base/button';
import { H2 } from '../base/typography';

export const FormStepWrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	padding: 2rem;
	border-radius: 1rem;
	box-shadow: 0 0 40px 0.1rem #00000014;
	margin-bottom: 2rem;
`;

interface FormStepHeadingProps {
	inactive?: boolean;
}

export const FormStepHeading = styled(H2)<FormStepHeadingProps>`
	color: ${({ inactive }) => (inactive ? theme.colorsV2.grey6 : theme.colors.primary)};
	font-family: ${theme.fonts.SharpSlab};
	font-weight: ${theme.fonts.weight.semiBold};
	font-size: 2.5rem;
	margin-bottom: 1rem;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-top: ${({ marginTop }) => marginTop || '0'};
`;

export const PrevButton = styled.span`
	margin-right: auto;
	margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
	margin-top: ${({ marginTop }) => marginTop || '0'};
	padding-left: 1rem;
	color: ${theme.colors.primary};
	font-family: ${theme.fonts.Arimo};
	font-weight: ${theme.fonts.weight.regular};
	font-size: 1.6rem;
	cursor: pointer;

	${({ disabled }) =>
		disabled &&
		`color: grey;
		pointer-events: none;
		`}

	${media.mobileAndTabletOnly`
		display: none;
		`}
`;

export const PrevButtonMobile = styled.span`
	display: none;
	margin-right: auto;
	margin-bottom: ${({ marginBottom }) => marginBottom || '2rem'};
	margin-top: ${({ marginTop }) => marginTop || '0'};
	color: ${theme.colors.primary};
	font-family: ${theme.fonts.Arimo};
	font-weight: ${theme.fonts.weight.semiBold};
	font-size: 1.6rem;
	cursor: pointer;

	${media.mobileAndTabletOnly`
		display: block;
		`}

	${({ disabled }) =>
		disabled &&
		`color: grey;
		pointer-events: none;
		`}
`;

export const ProceedButton = styled(Button)`
	margin-left: auto;
	margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
	margin-top: ${({ marginTop }) => marginTop || '0'};
	background: ${theme.colors.primary};
	border-radius: 1rem;
	color: ${theme.colors.white};

	&:disabled {
		background: ${theme.colorsV2.grey6};
	}

	${media.mobileAndTabletOnly`
		 width: 100%;`}
`;

export const ErrorMessage = styled.div`
	margin: 0.5rem;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colorsV2.alertRedSecondary};
`;

export const Label = styled.label`
	display: block;
	margin-bottom: ${({ marginBottom }) => marginBottom || '0.5rem'};
	margin-top: ${({ marginTop }) => marginTop || '0.5rem'};
	color: ${({ theme }) => theme.colors.textColor};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-weight: bold;
	font-size: 1.6rem;
`;
